module.exports = __webpack_public_path__ + "static/media/ChatApp-JS.3365bfb7.PNG";